module.exports = __webpack_public_path__ + "fonts/Graphik-LightItalic.3d7f5ac0.ttf";